/**
 * Created by Maria on 11/5/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminEvents', {
                parent: 'app',
                url: '/events',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_HEALTH_VISITOR', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_HEALTH_VISITOR', 'ROLE_PHARM_SUPERVISOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminEvents/adminEvents.html',
                        controller: 'AdminEventsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    customersView: ['ApplicationParameters', function (ApplicationParameters) {
                        return ApplicationParameters.customersView();
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
